






















































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import IPencil from '@/components/icons/IPencil.vue'
import ITrash from '@/components/icons/ITrash.vue'
import IClose from '@/components/icons/IClose.vue'
import BtnDefault from '@/components/UI/BtnDefault.vue';
import Modal from '@/components/UI/Modal.vue';
import {validatorMail} from "@/helpers/validators";

@Component({
  name: "edit-item",
  components: {
    IPencil,
    ITrash,
    IClose,
    BtnDefault,
    Modal
  }
})
export default class EditItem extends Vue {
  @Prop({type: String, default: ''}) modalTitle !: any
  @Prop({type: String, default: ''}) btnText !: any
  @Prop({type: String, default: ''}) textTitle !: any
  @Prop({type: String, default: ''}) textValue !: any
  @Prop({type: String, default: ''}) textModal !: any
  @Prop({type: String, default: ''}) typeValid !: any
  @Prop({type: Boolean, default: false}) isRequired !: any
  @Prop({type: Boolean, default: false}) isRequiredInput !: any
  @Prop({type: Boolean, default: false}) isTextarea !: any
  @Prop({type: Boolean, default: false}) isLink !: any
  @Prop({type: Boolean, default: false}) isTitleChange !: any
  @Prop({type: Boolean, default: false}) isDelete !: any
  @Prop({type: Boolean, default: true}) isNotSlot !: any
  @Prop({
    type: Object, default: () => {
    }
  }) item !: any

  show: boolean = false
  isError: boolean = false
  isErrorTitle: boolean = false
  isErrorTextarea: boolean = false
  isShowDeleteItem: boolean = false
  isErrorValid: boolean = false
  title: string = ''
  value: string = ''

  mounted() {
    this.title = this.item.title
    this.value = this.item.value
    window.addEventListener('mousedown', (e) => {
      if (!(e.target as HTMLInputElement).closest('.v-menu__content')) {
        this.show = false
      }
    })
  }

  @Watch('item')
  setItem() {
    this.title = this.item.title
    this.value = this.item.value
  }

  openModal() {
    this.title = this.item.title
    this.value = this.item.value
    this.isError = false
    this.isErrorTitle = false
    this.isErrorTextarea = false
    this.isErrorValid = false
    this.show = !this.show
    this.$emit('openModal')
  }

  save() {
    if (this.isNotSlot) {
      this.isError = !this.isTextarea && this.isRequiredFun()
      this.isErrorTitle = this.isTitleChange && this.title == ''
      this.isErrorTextarea = this.isTextarea && this.isRequiredFun()
      this.isErrorValid = this.typeValid != '' && !this.isValid()
    }
    if (!this.isError && !this.isErrorTitle && !this.isErrorTextarea && !this.isErrorValid) {
      this.item.value = this.value
      this.item.title = this.title
      this.update()
      this.$emit('save')
      this.show = false
      this.isError = false
    }
  }

  isRequiredFun() {
    return this.isRequired ? this.value === '' : false
  }

  isValid() {
    return this.typeValid == 'phone' ? this.validPhone() : this.typeValid == 'email' ? this.validEmail() : true
  }

  validEmail() {
    return validatorMail(this.value)
    // let re = /^[\w-\.]+@[\w-]+\.[a-z]{2,8}$/i;
    // return re.test(this.value)
  }

  validPhone() {
    let re = /^[\d\+][\d\(\)\ -]{4,20}\d$/
    return re.test(this.value)
  }

  update() {
    if (this.isTitleChange) {
      this.$emit('input', this.item)
    } else {
      this.$emit('input', this.value)
    }
  }

  deleteItem() {
    this.$emit('deleteItem', this.item)
    this.isShowDeleteItem = false
  }

  openDeleteModal() {
    this.isShowDeleteItem = true
  }

}
